import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/primitives";
import { Logo } from "@/components/site/Logo";
import { NAV_LINKS } from "@/data";

export const FinalCTA = ({ onBookDemo }) => (
  <section className="relative overflow-hidden bg-volt text-white">
    <div className="mx-auto max-w-[1400px] px-6 py-24 lg:px-10 lg:py-36">
      <Reveal>
        <div className="font-mono-p text-xs uppercase tracking-[0.3em] text-white/70">Ready to take control?</div>
        <h2 className="mt-6 max-w-4xl font-display text-5xl font-black leading-[0.9] sm:text-7xl lg:text-8xl">
          Know your warehouse. Run it better.
        </h2>
        <button
          data-testid="final-book-demo"
          onClick={onBookDemo}
          className="group mt-12 inline-flex items-center gap-3 bg-white px-8 py-5 font-display text-lg font-bold text-volt transition-transform hover:-translate-y-1"
        >
          Book a Demo
          <ArrowUpRight className="h-6 w-6 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={2.2} />
        </button>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white">
    <div className="mx-auto max-w-[1400px] px-6 py-16 lg:px-10">
      <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-500">
            Warehouse management, reimagined. One platform for inventory, operations,
            planning, production, pallets and 3PL.
          </p>
        </div>

        <div>
          <div className="font-mono-p text-[11px] uppercase tracking-widest text-slate-400">Navigate</div>
          <ul className="mt-4 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                {l.href.startsWith("/") ? (
                  <Link to={l.href} className="text-sm text-slate-500 transition-colors hover:text-volt">{l.label}</Link>
                ) : (
                  <a href={l.href} className="text-sm text-slate-500 transition-colors hover:text-volt">{l.label}</a>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-mono-p text-[11px] uppercase tracking-widest text-slate-400">Features</div>
          <ul className="mt-4 space-y-3 text-sm">
            {[
              { m: "Inventory", to: "/features/inventory" },
              { m: "Inbound", to: "/features/inbound" },
              { m: "Outbound", to: "/features/outbound" },
            ].map((x) => (
              <li key={x.m}>
                <Link to={x.to} className="text-slate-500 transition-colors hover:text-volt">{x.m}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-8 sm:flex-row sm:items-center">
        <span className="font-mono-p text-xs text-slate-400">© {new Date().getFullYear()} Stockaris WMS. All rights reserved.</span>
        <span className="font-mono-p text-xs text-slate-400">Built from experience on the warehouse floor.</span>
      </div>
    </div>
  </footer>
);
